const RankingColumns = [
  {
    name: "RANK",
    value: "rank",
    show: true,
    isBold: true,
  },
  {
    name: "NAME OF THE INSTITUTE",
    value: "name",
    show: true,
    isBold: true,
  },
  {
    name: "REGION",
    value: "region",
    show: true,
    isBold: true,
  },
  {
    name: "CITY",
    value: "city",
    show: true,
    isBold: true,
  },
  {
    name: "GOVERNMENT/PRIVATE",
    value: "institution_type",
    show: true,
    isBold: true,
  },
  {
    name: "ADMISSION ATTRACTIVENESS",
    value: "admission_attractiveness",
    show: true,
    isBold: true,
  },
  {
    name: "AGE & BRAND APPEAL",
    value: "age_and_accreditation",
    show: true,
    isBold: true,
  },
  {
    name: "PLACEMENT & ROI",
    value: "placement_and_roi",
    show: true,
    isBold: true,
  },
  {
    name: "PEDAGOGY & INFRASTRUCTURE",
    value: "pedagogy_and_infrastructure",
    show: true,
    isBold: true,
  },
  {
    name:"INDUSTRY CONNECT",
    value: "industry_connect",
    show: true,
    isBold: true,
  },
  {
    name: "ABSOLUTE SCORE",
    value: "absolute_score",
    show: true,
    isBold: true,
  },
  {
    name: "PERCEPTION SCORE",
    value: "perception_index",
    show: true,
    isBold: true,
  },
  {
    name: "TOTAL SCORE",
    value: "total_score",
    show: true,
    isBold: true,
  },
  {
    name: "DISTANCE TO FRONTIER SCORE",
    value: "distance_to_frontier_score",
    show: true,
    isBold: true,
  },
];

export default RankingColumns;
